import React, { useState } from 'react';
import axios from 'axios';

export default function LoginRegister({ onLogin, sesionVencida }) {
  // 'login' | 'register' | 'olvide' | 'nueva'
  const [mode, setMode] = useState('login');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [password2, setPassword2] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [error, setError] = useState('');
  const [aviso, setAviso] = useState('');
  const [token, setToken] = useState('');
  const [loading, setLoading] = useState(false);

  // Empieza siempre en login, salvo que se llegue desde el enlace del correo
  // de recuperación, que trae el token en la dirección.
  React.useEffect(() => {
    const tokenUrl = new URLSearchParams(window.location.search).get('token');
    if (tokenUrl) {
      setToken(tokenUrl);
      setMode('nueva');
    } else {
      setMode('login');
    }
  }, []);

  const limpiar = () => { setError(''); setAviso(''); };

  const handleOlvide = async (e) => {
    e.preventDefault();
    limpiar();
    setLoading(true);
    try {
      const res = await axios.post('/api/auth/forgot-password', { email });
      setAviso(res.data.message || 'Revisa tu correo.');
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo enviar el correo');
    } finally {
      setLoading(false);
    }
  };

  const handleNuevaClave = async (e) => {
    e.preventDefault();
    limpiar();

    if (password !== password2) {
      setError('Las dos contraseñas no coinciden');
      return;
    }

    setLoading(true);
    try {
      await axios.post('/api/auth/reset-password', { token, password });
      // Se quita el token de la dirección para que no quede en el historial
      // del navegador ni se reutilice al recargar.
      window.history.replaceState({}, '', window.location.pathname);
      setPassword('');
      setPassword2('');
      setMode('login');
      setAviso('✅ Contraseña cambiada. Ya puedes iniciar sesión.');
    } catch (err) {
      setError(err.response?.data?.error || 'No se pudo cambiar la contraseña');
    } finally {
      setLoading(false);
    }
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await axios.post('/api/auth/login', {
        email,
        password
      });

      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      onLogin(user, token);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al iniciar sesión');
    } finally {
      setLoading(false);
    }
  };

  const handleRegister = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const res = await axios.post('/api/auth/register', {
        email,
        password,
        companyName
      });

      const { token, user } = res.data;
      localStorage.setItem('token', token);
      localStorage.setItem('user', JSON.stringify(user));

      onLogin(user, token);
    } catch (err) {
      setError(err.response?.data?.error || 'Error al registrarse');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      padding: '20px'
    }}>
      <div style={{
        width: '100%',
        maxWidth: '400px',
        backgroundColor: 'white',
        borderRadius: '12px',
        padding: '40px',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)'
      }}>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <h1 style={{ fontSize: '32px', margin: '0 0 10px 0' }}>💎</h1>
          <h2 style={{ margin: '0 0 5px 0', color: '#1f2937' }}>FlexFlow Pro</h2>
          <p style={{ margin: '0', color: '#6b7280', fontSize: '14px' }}>
            Gestión inteligente de préstamos
          </p>
        </div>

        {/* Por qué está viendo esta pantalla otra vez. Sin decirlo, quien
            estaba trabajando cree que se le borraron los datos: es exactamente
            lo que le pasó a un cliente con 177 clientes registrados. */}
        {sesionVencida && !error && (
          <div style={{
            backgroundColor: '#fef3c7',
            color: '#92400e',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '20px',
            fontSize: '14px',
            lineHeight: 1.5
          }}>
            🔒 <strong>Se cerró la sesión por seguridad.</strong> Entra otra vez
            con tu correo y tu clave. <strong>No se perdió nada</strong>: tus
            clientes y tus préstamos siguen ahí.
          </div>
        )}

        {error && (
          <div style={{
            backgroundColor: '#fee2e2',
            color: '#991b1b',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            ❌ {error}
          </div>
        )}

        {aviso && (
          <div style={{
            backgroundColor: '#f0fdf4',
            color: '#166534',
            padding: '12px',
            borderRadius: '6px',
            marginBottom: '20px',
            fontSize: '14px'
          }}>
            {aviso}
          </div>
        )}

        {mode === 'login' && (
          <form onSubmit={handleLogin}>
            <h3 style={{ marginBottom: '20px', color: '#1f2937' }}>Iniciar Sesión</h3>

            {/* Estos atributos son lo que hace que el teléfono ofrezca guardar
                la clave y luego rellenarla con Face ID o huella. Sin ellos,
                Safari no reconoce el formulario como un inicio de sesión. */}
            <input
              type="email"
              placeholder="Email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />

            <input
              type="password"
              placeholder="Contraseña"
              autoComplete="current-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '20px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#667eea',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontWeight: 'bold',
                fontSize: '14px',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? '⏳ Iniciando...' : '✨ Iniciar Sesión'}
            </button>

            <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280', fontSize: '14px' }}>
              ¿No tienes cuenta?{' '}
              <button
                type="button"
                onClick={() => { setMode('register'); setError(''); }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#667eea',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                Regístrate
              </button>
            </p>

            <p style={{ textAlign: 'center', marginTop: '10px' }}>
              <button
                type="button"
                onClick={() => { setMode('olvide'); limpiar(); }}
                style={{
                  background: 'none', border: 'none', color: '#6b7280',
                  cursor: 'pointer', textDecoration: 'underline', fontSize: '13px'
                }}
              >
                ¿Olvidaste tu contraseña?
              </button>
            </p>
          </form>
        )}

        {mode === 'register' && (
          <form onSubmit={handleRegister}>
            <h3 style={{ marginBottom: '20px', color: '#1f2937' }}>Crear Cuenta</h3>

            <input
              type="text"
              placeholder="Nombre de tu empresa"
              autoComplete="organization"
              value={companyName}
              onChange={(e) => setCompanyName(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />

            <input
              type="email"
              placeholder="Email"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '15px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />

            <input
              type="password"
              placeholder="Contraseña"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              style={{
                width: '100%',
                padding: '12px',
                marginBottom: '20px',
                border: '1px solid #e5e7eb',
                borderRadius: '6px',
                fontSize: '14px',
                boxSizing: 'border-box'
              }}
            />

            <button
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '12px',
                backgroundColor: '#10b981',
                color: 'white',
                border: 'none',
                borderRadius: '6px',
                cursor: loading ? 'not-allowed' : 'pointer',
                fontWeight: 'bold',
                fontSize: '14px',
                opacity: loading ? 0.7 : 1
              }}
            >
              {loading ? '⏳ Creando cuenta...' : '🚀 Crear Cuenta'}
            </button>

            <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280', fontSize: '14px' }}>
              ¿Ya tienes cuenta?{' '}
              <button
                type="button"
                onClick={() => { setMode('login'); setError(''); }}
                style={{
                  background: 'none',
                  border: 'none',
                  color: '#667eea',
                  cursor: 'pointer',
                  textDecoration: 'underline',
                  fontSize: '14px',
                  fontWeight: 'bold'
                }}
              >
                Inicia sesión
              </button>
            </p>
          </form>
        )}

        {mode === 'olvide' && (
          <form onSubmit={handleOlvide}>
            <h3 style={{ marginBottom: '10px', color: '#1f2937' }}>Recuperar contraseña</h3>
            <p style={{ marginTop: 0, marginBottom: '20px', color: '#6b7280', fontSize: '14px' }}>
              Escribe tu correo y te enviaremos un enlace para elegir una nueva.
              Caduca en una hora.
            </p>

            <input
              type="email"
              placeholder="Tu correo"
              autoComplete="username"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              style={{
                width: '100%', padding: '12px', marginBottom: '15px',
                border: '1px solid #e5e7eb', borderRadius: '6px',
                fontSize: '14px', boxSizing: 'border-box'
              }}
            />

            <button type="submit" disabled={loading} style={{
                width: '100%', padding: '12px', backgroundColor: '#667eea',
                color: 'white', border: 'none', borderRadius: '6px',
                cursor: loading ? 'not-allowed' : 'pointer', fontWeight: 'bold',
                fontSize: '14px', opacity: loading ? 0.7 : 1
              }}>
              {loading ? '⏳ Enviando...' : '📧 Enviarme el enlace'}
            </button>

            <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280', fontSize: '14px' }}>
              <button
                type="button"
                onClick={() => { setMode('login'); limpiar(); }}
                style={{
                  background: 'none', border: 'none', color: '#667eea',
                  cursor: 'pointer', textDecoration: 'underline',
                  fontSize: '14px', fontWeight: 'bold'
                }}
              >
                ← Volver
              </button>
            </p>
          </form>
        )}

        {mode === 'nueva' && (
          <form onSubmit={handleNuevaClave}>
            <h3 style={{ marginBottom: '10px', color: '#1f2937' }}>Elige tu nueva contraseña</h3>
            <p style={{ marginTop: 0, marginBottom: '20px', color: '#6b7280', fontSize: '14px' }}>
              Mínimo 6 caracteres.
            </p>

            <input
              type="password"
              placeholder="Nueva contraseña"
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={6}
              style={{
                width: '100%', padding: '12px', marginBottom: '15px',
                border: '1px solid #e5e7eb', borderRadius: '6px',
                fontSize: '14px', boxSizing: 'border-box'
              }}
            />

            <input
              type="password"
              placeholder="Repite la contraseña"
              autoComplete="new-password"
              value={password2}
              onChange={(e) => setPassword2(e.target.value)}
              required
              style={{
                width: '100%', padding: '12px', marginBottom: '15px',
                border: '1px solid #e5e7eb', borderRadius: '6px',
                fontSize: '14px', boxSizing: 'border-box'
              }}
            />

            <button type="submit" disabled={loading} style={{
                width: '100%', padding: '12px', backgroundColor: '#667eea',
                color: 'white', border: 'none', borderRadius: '6px',
                cursor: loading ? 'not-allowed' : 'pointer', fontWeight: 'bold',
                fontSize: '14px', opacity: loading ? 0.7 : 1
              }}>
              {loading ? '⏳ Guardando...' : '🔐 Cambiar contraseña'}
            </button>

            <p style={{ textAlign: 'center', marginTop: '20px', color: '#6b7280', fontSize: '14px' }}>
              <button
                type="button"
                onClick={() => {
                  window.history.replaceState({}, '', window.location.pathname);
                  setMode('login');
                  limpiar();
                }}
                style={{
                  background: 'none', border: 'none', color: '#667eea',
                  cursor: 'pointer', textDecoration: 'underline',
                  fontSize: '14px', fontWeight: 'bold'
                }}
              >
                ← Volver
              </button>
            </p>
          </form>
        )}

        <div style={{
          marginTop: '30px',
          paddingTop: '20px',
          borderTop: '1px solid #e5e7eb',
          fontSize: '12px',
          color: '#9ca3af',
          textAlign: 'center'
        }}>
          <p style={{ margin: '0 0 10px 0' }}>🔒 Datos encriptados con HTTPS</p>
          <p style={{ margin: '0' }}>© 2026 FlexFlow Pro</p>
        </div>
      </div>
    </div>
  );
}
